/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Creates a third party callout
 *
 * @module enervee_utils.third_party_integrations
 */
function thirdPartyCalloutDirective() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            type: '<',
            link: '<',
            product: '<?',
            category: '<'
        },
        controller: thirdPartyCalloutController,
        template: require('./thirdPartyCalloutView.html')
    };
}

thirdPartyCalloutController.$inject = [
    '$log',
    '$scope',
    'AnalyticsService',
    'CmsContentService',
    'DisclosuresModalService',
    'HomeAdvisorModalService',
    'SolarService'
];
function thirdPartyCalloutController (
    $log,
    $scope,
    AnalyticsService,
    CmsContentService,
    DisclosuresModalService,
    HomeAdvisorModalService,
    SolarService
) {
    this.$onInit = function () {
        $scope.homeAdvisorModalService = HomeAdvisorModalService;
        if ($scope.product) {
            $scope.homeAdvisorModalService.registerProduct($scope.product);
        }
        $scope.buttonClickFunctionMap = {
            home_advisor: "homeAdvisorModalService.openModal(category.id)",
        };

        if (SolarService.isEnabled) {
            $scope.solarService = SolarService;
            $scope.buttonClickFunctionMap.pick_my_solar = "solarService.goToSolar('widget', product, false)";
            $scope.buttonClickFunctionMap.battery = "solarService.goToSolar('widget', product, false, 'battery')";
            $scope.buttonClickFunctionMap.heat_pumps = "solarService.goToSolar('widget', product, false, 'heatPumps')";
        }

        const cmsKeyBase = 'base:third_party_callout:' + $scope.type;
        CmsContentService.getMarketPlaceText(
            cmsKeyBase + "_button_text",
            {},
            $scope.category.id
        ).then(function(text) {
            $scope.buttonText = text;
        });
        CmsContentService.getMarketPlaceText(
            cmsKeyBase + "_text",
            {},
            $scope.category.id
        ).then(function(text) {
            $scope.calloutText = text;
        });
        CmsContentService.getMarketPlaceText(
            cmsKeyBase + "_logo",
            {},
            $scope.category.id
        ).then(function(text) {
            $scope.logo = text;
        });
        CmsContentService.getMarketPlaceText(
            cmsKeyBase + "_icon",
            {},
            $scope.category.id
        ).then(function(text) {
            $scope.icon = text;
        });

        $scope.openPromo = function () {
            AnalyticsService.reportEvent('Promo Clicked', {
                type: $scope.type.replace('_', ' '),
                location: 'sidebar',
                category: $scope.category.category_code
            }, $scope.product);

            DisclosuresModalService.openThirdPartyModal($scope.type).then((result) => {
                if (result && result.continue) {
                    if ($scope.buttonClickFunctionMap.hasOwnProperty($scope.type)) {
                        $scope.$eval($scope.$eval("buttonClickFunctionMap[type]"));
                    }
                }
            });
        };

        $scope.trackPromoViewed = function () {
            AnalyticsService.reportEvent('Promo Viewed', {
                type: $scope.type.replace('_', ' '),
                location: 'sidebar',
                category: $scope.category.category_code
            }, $scope.product);
        };
    };
}

module.exports = thirdPartyCalloutDirective;
